import { render, staticRenderFns } from "./SelectIntegrationList.vue?vue&type=template&id=2b55207e&scoped=true"
import script from "./SelectIntegrationList.vue?vue&type=script&lang=js"
export * from "./SelectIntegrationList.vue?vue&type=script&lang=js"
import style0 from "./SelectIntegrationList.vue?vue&type=style&index=0&id=2b55207e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55207e",
  null
  
)

export default component.exports